import { ImmoService, ImmoError } from '@/services/immo.service'
import {
  IMMO_ERROR,
  IMMO_LIST_REQUEST,
  IMMO_LIST_ERROR,
  IMMO_LIST_SUCCESS,
  IMMO_LIST_PAGE,
  IMMO_LIST_FILTER,
  IMMO_MAP_FILTER,
  IMMO_MAP_REQUEST,
  IMMO_MAP_ERROR,
  IMMO_MAP_SUCCESS,
  CUSTOMER_REQUEST
} from './actions'

const state = {
  status: '',

  immoList: {
    immos: [],
    count: 0
  },
  immoMap: {
    immos: [],
    count: 0
  }
}

const getters = {
  immoList: state => state.immoList.immos,
  listCount: state => state.immoList.count,
  immoMap: state => state.immoMap.immos.filter(v => !!v.location.lat),
  mapCount: state => state.immoMap.count
}

const actions = {

  async [IMMO_LIST_REQUEST]({ commit }, filter) {
    commit(IMMO_LIST_REQUEST)
    try {
      const data = await ImmoService.getImmoList(filter)
      commit(IMMO_LIST_SUCCESS, data)
    } catch (e) {
      if (e instanceof ImmoError) {
        commit(IMMO_LIST_ERROR, {
          errorCode: e.errorCode,
          errorMessage: e.message
        })
      }
      return false
    }
  },
  async [IMMO_LIST_FILTER]({ state, commit, dispatch }, filter) {
    commit(IMMO_LIST_FILTER, filter)
    dispatch(IMMO_LIST_REQUEST, state.immoList.filter)
  },
  async [IMMO_LIST_PAGE]({ commit, dispatch }, page) {
    commit(IMMO_LIST_PAGE, page)
    dispatch(IMMO_LIST_REQUEST)
  },

  async [IMMO_MAP_REQUEST]({ commit, dispatch }, filter) {
    commit(IMMO_MAP_REQUEST)
    try {
      const data = await ImmoService.getImmoList(filter)
      commit(IMMO_MAP_SUCCESS, data)
      dispatch(CUSTOMER_REQUEST, filter)
    } catch (e) {
      if (e instanceof ImmoError) {
        commit(IMMO_LIST_ERROR, {
          errorCode: e.errorCode,
          errorMessage: e.message
        })
      }
      return false
    }
  },
  async [IMMO_MAP_FILTER]({ state, commit, dispatch }, filter) {
    commit(IMMO_MAP_FILTER, filter)
    dispatch(IMMO_MAP_REQUEST, state.immoList.filter)
  }
}

const mutations = {
  [IMMO_ERROR]: (state, { errorCode, errorMessage }) => {
    state.errorCode = errorCode
    state.errorMessage = errorMessage
  },
  [IMMO_LIST_REQUEST]: state => {
    state.status = 'loading'
  },
  [IMMO_LIST_SUCCESS]: (state, data) => {
    state.immoList.immos = data.immos
    state.immoList.count = data.count
  },
  [IMMO_LIST_ERROR]: (state, { errorCode, errorMessage }) => {
    state.errorCode = errorCode
    state.errorMessage = errorMessage
  },
  [IMMO_LIST_PAGE]: (state, page) => {
    state.filter.page = page
  },
  [IMMO_LIST_FILTER]: (state, filter) => {
    state.immoList.filter = filter
  },
  [IMMO_MAP_REQUEST]: state => {
    state.status = 'loading'
  },
  [IMMO_MAP_SUCCESS]: (state, data) => {
    state.immoMap.immos = data.immos
    state.immoMap.count = data.count
  },
  [IMMO_MAP_ERROR]: (state, { errorCode, errorMessage }) => {
    state.errorCode = errorCode
    state.errorMessage = errorMessage
  },
  [IMMO_MAP_FILTER]: (state, filter) => {
    state.immoMap.filter = filter
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
